import React from 'react'
import { Box, Chip, Paper, Typography } from '@mui/material'

export const readable = value => value ? value.toLowerCase().replaceAll('_', ' ').replace(/^./, c => c.toUpperCase()) : '—'
export const money = value => Number(value || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
export const accountTypeLabel = value => value === 'BUSINESS' ? 'Business user' : readable(value)
export const providerLabel = value => value === 'hug' ? 'Email/password' : readable(value)
export function StatusChip({ status }) {
  const color = { ACTIVE: 'success', DORMANT: 'default', SUSPENDED: 'warning', ARCHIVED: 'default' }[status] || 'default'
  return <Chip size="small" variant="outlined" label={readable(status)} color={color} />
}
export function Section({ title, action, children }) {
  return <Paper component="section" variant="outlined" sx={{ overflow: 'hidden' }}>
    <Box px={2.5} py={2} display="flex" alignItems="center" justifyContent="space-between" gap={2} borderBottom="1px solid" borderColor="divider">
      <Typography variant="subtitle1" fontWeight={600}>{title}</Typography>{action}
    </Box><Box p={2.5}>{children}</Box>
  </Paper>
}
export function Field({ label, children }) {
  return <Box sx={{ minWidth: 0 }}><Typography variant="body2" color="text.secondary" mb={0.5}>{label}</Typography><Typography component="div" sx={{ overflowWrap: 'anywhere' }}>{children ?? '—'}</Typography></Box>
}
